import * as React from 'react';
import * as A from 'fp-ts/Array';
import { FullMatchFragment } from '../../../generated/graphql';
import { Card } from '../../../components/Card';
import { paths } from '../../../paths';
import { CardHeading } from '../../../components/CardHeading';
import { isNil } from '../../../utils/isNil';
import { TodoItem } from '../../../components/TodoItem';

interface Props {
  match: Pick<FullMatchFragment, 'id' | 'location' | 'players' | 'kitItems'>;
}

export const PreMatchPrompts: React.FC<Props> = ({ match }) => {
  const completions = {
    location: !isNil(match.location),
    players: A.isNonEmpty(match.players),
    kitItems: A.isNonEmpty(match.kitItems),
  };

  return (
    <Card className="space-y-6">
      <CardHeading>Add Match Info</CardHeading>
      <ul className="space-y-3">
        <TodoItem
          complete={completions.location}
          linkTo={paths.match.settings.location(match.id)}
        >
          Set Location
        </TodoItem>

        <TodoItem
          complete={completions.players}
          linkTo={paths.match.settings.squad(match.id)}
        >
          Pick Squad
        </TodoItem>
        <TodoItem
          complete={completions.kitItems}
          linkTo={paths.match.settings.kit(match.id)}
        >
          Set Kit
        </TodoItem>
      </ul>
    </Card>
  );
};
